import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';

import caretDownCultured from '../../assets/caret-down-solid-cultured-70.png';
import caretDownJellyBean from '../../assets/caret-down-solid-jelly-bean-100.png';
import frown from '../../assets/frown-solid-cultured-50.png';
import checkGamboge from '../../assets/check-solid-gamboge-100.png';
import checkCultured from '../../assets/check-solid-cultured-50.png';

import Wrapper from "./wrapper";
import inputStyles from '../../styles/base_components/Input.module.scss';
import styles from '../../styles/base_components/MultiSelect.module.scss';
import {isEmptyObject} from "../../utils/utils";

/**
 * @param {string} props.className
 * @param {string} props.defaultPlaceholder
 * @param {string} props.input
 * @param {function} props.setInput
 * @param {boolean} props.singleSelect
 * @param {string} props.placeholder
 * @param {function} props.setPlaceholder
 * @param {Object} props.items
 * @param {function} props.setItems
 * @param {string} props.error not required
 * @param {function} props.setError not required
 */
function Select(props) {
  const ref = useRef(null);
  const [showList, setShowList] = useState(false);
  const [filteredItems, setFilteredItems] = useState(props.items);

  function onChangeInput(event) {
    props.setInput(event.target.value);
    props.setError && props.setError('');
  }

  function onToggleBody(event) {
    event.stopPropagation();
    setShowList(showBody => !showBody);
  }

  function onClickItem(event, item) {
    event.stopPropagation();
    const value = filteredItems[item];

    if (props.singleSelect) {
      props.setItems(items => {
        let newItems = {};
        for (let key in items) {
          newItems[key] = (key === item);
        }
        return newItems;
      });
      setFilteredItems(items => {
        let newItems = {};
        for (let key in items) {
          newItems[key] = (key === item);
        }
        return newItems;
      });

      props.setPlaceholder(item);
      props.setError && props.setError('');
      return;
    }

    props.setItems(items => {
      items[item] = !value;
      return {...items};
    });
    setFilteredItems(items => {
      items[item] = !value;
      return {...items};
    });

    if (!value) {  // selecting the item
      props.setPlaceholder(placeholder => placeholder === '' ? item : placeholder + ', ' + item);
      props.setError && props.setError('');
    } else {  // unselecting the item
      props.setPlaceholder(placeholder => {
        if (placeholder === item) return '';
        if (placeholder.endsWith(item)) return placeholder.replace(', ' + item, '');
        return placeholder.replace(item + ', ', '');
      });
    }
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) setShowList(false);
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref]);

  useEffect(() => {
    function filterItems() {
      if (props.input.trim() === '') {
        setFilteredItems(props.items);
        return;
      }

      let newItems = {};
      Object.keys(props.items)
        .filter(item => item.toLowerCase().includes(props.input.toLowerCase()))
        .forEach(item => {
          newItems[item] = props.items[item];
        });

      if (isEmptyObject(newItems)) setShowList(false);
      else {
        setFilteredItems(newItems);
        setShowList(true);
      }
    }

    const timer = setTimeout(filterItems, 500);
    return () => clearTimeout(timer);
  }, [props.items, props.input]);

  return (
    <Wrapper className={styles.multiSelect + ' ' + props.className} ref={ref} error={props.error} showList={showList}>
      <div className={inputStyles.input + ' ' + styles.input}>
        <input
          placeholder={props.placeholder ? props.placeholder : props.defaultPlaceholder}
          value={props.input}
          onClick={() => setShowList(true)}
          onChange={onChangeInput}
        />
        <img
          src={props.error ? caretDownJellyBean : caretDownCultured}
          alt='Caret down solid'
          onClick={onToggleBody}
        />
        <p>{props.error}</p>
      </div>

      <div className={styles.list}>
        {Object.keys(filteredItems).length === 0 ?
          <div className={styles.notFound}>
            <img src={frown} alt='Frown Solid Cultured 50'/>
            <p>Nothing found</p>
          </div> :
          Object.keys(filteredItems).map(item => (
            <div className={styles.found} key={item} onClick={event => onClickItem(event, item)}>
              <img src={filteredItems[item] ? checkGamboge : checkCultured} alt='Check Solid'/>
              <p>{item}</p>
            </div>
          ))}
      </div>
    </Wrapper>
  );
}

export default Select;